import React from 'react';
import { FaServer, FaCheck, FaTimes, FaSpinner } from 'react-icons/fa';

const ServerSelector = ({ results, selectedSource, onSourceSelect }) => {
  const getStatusIcon = (result) => {
    if (result.success) {
      return <FaCheck className="status-icon success" />;
    } else {
      return <FaTimes className="status-icon error" />;
    }
  };

  const getStatusClass = (result) => {
    if (result.success) {
      return 'server-button success';
    } else {
      return 'server-button error';
    }
  };

  return (
    <div className="server-selector">
      {Object.entries(results).map(([sourceId, result]) => (
        <button
          key={sourceId}
          className={`${getStatusClass(result)} ${selectedSource === sourceId ? 'selected' : ''}`}
          onClick={() => onSourceSelect(sourceId, result)}
          disabled={!result.success}
        >
          <FaServer className="server-icon" />
          <span className="server-name">{result.name}</span>
          {getStatusIcon(result)}
        </button>
      ))}
    </div>
  );
};

export default ServerSelector;
